exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-click-confirm {\n  position: absolute;\n  z-index: 1100;\n  padding: 1.3em 0 0 1.3em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/click-confirm.less
// module id = 195
// module chunks = 0